<script>
import { onUserReady } from '@/config/auth';

import TheMessages from '@/components/TheMessages.vue';
import TheHeader from '@/components/TheHeader.vue';
import TheNav from '@/components/TheNav.vue';
import TheFaq from '@/components/TheFaq.vue';

export default {
  metaInfo: {
    titleTemplate(chunk) {
      return chunk === 'VCardConverter' ? chunk : `${chunk} - VCardConverter`;
    },
  },

  components: {
    TheMessages,
    TheHeader,
    TheNav,
    TheFaq,
  },

  data() {
    return {
      isReady: false,
    };
  },

  created() {
    onUserReady(() => {
      this.isReady = true;
    });
  },
};
</script>

<template>
  <div id="app" class="app">
    <div v-if="isReady">
      <the-header />
      <the-nav class="app_main_nav" />

      <div class="app_main">
        <router-view />
        <div class="container mt-15">
          <the-faq />
        </div>
      </div>
    </div>
    <div
      v-else
      class="flex fdirection-column jcontent-center aitems-center h-screen p-5 fsize-6 color-main"
    >
      <h1 class="fsize-6 color-black">
        <ion-icon class="valign-middle" :src="require('@/assets/img/logo.svg')" />
        <span class="pl-2 valign-middle">VCardConverter</span>
      </h1>
      <p v-t="'loading'" />
    </div>
    <teleport-target name="modals" />
    <the-messages />
  </div>
</template>

<style lang="scss">
.app {
  &_main {
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;

    &_nav {
      position: absolute;
      z-index: 100;
      top: 120px;
      right: 0;
      width: 260px;

      @include touch {
      }
    }
  }
}
</style>
